// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__34zP2","legacyBtn":"MutateMid_legacyBtn__2FlFy"};